import { render, staticRenderFns } from "./detail-tables.vue?vue&type=template&id=26078d76&scoped=true"
import script from "./detail-tables.vue?vue&type=script&lang=js"
export * from "./detail-tables.vue?vue&type=script&lang=js"
import style0 from "./detail-tables.vue?vue&type=style&index=0&id=26078d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26078d76",
  null
  
)

export default component.exports